import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Layout from '@/components/Layout';
import Dashboard from '@/pages/Dashboard';
import PSRental from '@/pages/PSRental';
import Food from '@/pages/Food';
import History from '@/pages/History';

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/rental" element={<PSRental />} />
            <Route path="/makanan" element={<Food />} />
            <Route path="/riwayat" element={<History />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: '#131B2E',
            border: '1px solid rgba(0, 240, 255, 0.3)',
            color: '#F8FAFC',
          },
        }}
      />
    </div>
  );
}

export default App;
